/**
 * @file 打点接口封装
 * @author
 */
import {Url} from '@/utils/api.js';
import store from '../store/main';
import md5 from 'crypto-js/md5';

export const EventType = {
    ShowLog: 1,
    ClickLog: 2,
    TimeLog: 3,
    OtherLog: 99
};

export const getTraceId = () => {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now();
    }

    const traceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (String(c) === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return traceId;
};

const SECURTKEY = 'pDCYt64Z_mqX';
export const sendLog = (inputData = {}) => {
    // const uid = store.raw.userInfo && store.raw.userInfo.loginUser.eni;
    const uid ='YWRzZmFzZGZhc2Q=';
    // 包装 uid
    const {
        eventName = '',
        eventType = EventType.ShowLog,
        owner = 'jiangyunbin',
        from = '',
        extDesc = {},
        parents = '',
        clickName = '',
        ext = {}
    } = inputData;
    let {
        traceId = '',
        eventCode = ''
    } = inputData;
    // uid是接口异步获取，非必须，可不必为空校验
    // if (!uid) {
    //     console.log(new Error('uid获取失败'));
    //     return;
    // }
    if (!eventCode) {
        console.log(new Error('请传入eventCode'));
        return;
    }

    if (!eventName) {
        console.log(new Error('请传入eventName'));
        return;
    }

    if (eventType === EventType.TimeLog && !traceId) {
        traceId = getTraceId();
        eventCode += '_BEGIN';
    }
    else if (eventType === EventType.TimeLog) {
        eventCode += '_END';
    }

    const matchResult = location.pathname.match(/\/(\w*)\.html/);
    const page = matchResult && matchResult[1] || '';

    const submitContent = {
        page,
        from,
        traceId,
        ext: {
            ...ext,
            parents,
            clickName
        }
    };

    const submitData = {
        sysId: 102,
        eventCode,
        eventName,
        eventType,
        extDesc: JSON.stringify({...extDesc, parents: '父级页面', clickName: '事件名称'}),
        owner,
        uid,
        timestamp: Date.now(),
        content: submitContent
    };

    const data = JSON.stringify(submitData);

    const host = location.host;
    let dataHost = '';
    if (host === 'ossunion.baidu.com') {
        dataHost = 'https://smartprogram.baidu.com';
    }
    else {
        // 测试环境，测试环境暂不入库
        // dataHost = 'http://platform-test.bcc-bdbl.baidu.com:8019';
        dataHost =  'https://smartprogram.baidu.com';
    }
    const DATA_LOG = `${dataHost}${Url.osReportUrl}`;
    const vc = md5(`${data}${SECURTKEY}`);
    let url = `${DATA_LOG}?data=${encodeURIComponent(data)}&vc=${vc}`;

    if (url.length > 2000) {
        console.log(new Error('参数过长.超过2000字节'));
        return;
    }

    return new Promise(resolve => {
        let img = new Image();
        img.onload = () => {
            resolve(traceId);
        };
        img.onerror = () => {
            resolve(traceId);
        };
        img.src = url;
    });
};
